<template>
  <div v-if="doses" class="white">
    <vetalfa-section-title :prop="labels.DOSES_TAB_SECTION_TITLE">
      <vetalfa-dose-card
        v-for="(dose, index) in doses"
        :key="`${index}-${dose.title}`"
        :isDrugsManagement="isDrugsManagement"
        class="py-2"
        isCard
        :prop="dose"
        :index="index"
      ></vetalfa-dose-card>
    </vetalfa-section-title>
    <div style="height: 30px; background-color: white"></div>
  </div>
</template>

<style>
</style>

<script>
import {} from "@mdi/js";
import labels from "@/constants/labels.js";
export default {
  name: "DosesTab",
  computed: {},
  props: {
    doses: {
      type: Array,
    },
    isDrugsManagement: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      labels,
    };
  },
};
</script>